<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户贷款'}, {label: '贷款详情'}]"/>
    <div>
      <financing-view-component
        :financing-detail-data="financingDetailData"
        :transactionId="transactionId"
        :repayment-plan-list="repaymentPlanList"
        :repayment-list="repaymentList"
        :pay-pledge-financing-data="payPledgeFinancingData"
      ></financing-view-component>
    </div>
    <button-back></button-back>
  </div>
</template>

<script>
  import FinancingViewComponent from '../../components/FinancingViewComponent'
  import ButtonBack from '../../../components/ButtonBack'
  import xhr from '../../../utils/xhr'


  export default {
    name: "ServerAdminFinancingDetail",
    data() {
      return {
        transactionId: this.$route.query['fi.transactionId'],
        financingDetailData: {},
        contractData: {},
        payPledgeFinancingData: {},
        repaymentPlanList: {
          data:[],
          count: 0
        },
        repaymentList: {
          data: [],
          count:0
        }
      }
    },
    components: {
      FinancingViewComponent,
      ButtonBack
    },
    mounted() {
      if( this.transactionId ) {
        this.getCustomerFinancingDetail()
        this.getCustomerRepaymentPlanList()
        this.getCustomerRepaymentList()
        this.payPledgeFinancing(this.transactionId)
      }
    },
    methods: {
      getCustomerFinancingDetail: function (transactionId = this.transactionId) {
        xhr.getCustomerFinancingDetail(
          {
            'fi.transactionId' : transactionId
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.financingDetailData = res.data.data
               /* this.getCustomerContractDetail(this.financingDetailData.fi__contractId)*/
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerRepaymentPlanList: function (transactionId = this.transactionId) {
        xhr.getCustomerRepaymentPlanList(
          {
            'plan.transactionId': transactionId
          },
          res=>{
            try {
              if( res.data.status == 'success' && res.data.data ) {
                this.repaymentPlanList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerRepaymentList: function (transactionId = this.transactionId) {
        xhr.getCustomerRepaymentList(
          {
            'xlist.search.fi.transactionId': transactionId,
            'xlist.search.fi.transactionId.op': 'eq'
          },
          res=> {
            try {
              if(res.data.status == 'success' && res.data.data) {
                this.repaymentList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      payPledgeFinancing : function (transactionId = this.transactionId){
        xhr.getCustomerPaymentList(
          {
            'xlist.search.fi.transactionId': transactionId,
            'xlist.search.fi.transactionId.op': 'eq'
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                  this.payPledgeFinancingData = res.data.data.shift()
              }
            }catch (e) {

            }
          }
        )
      }
      //合同详情
     /* getCustomerContractDetail: function (contractId) {
        xhr.getCustomerContractDetail(
          {
            'ct.contractId': contractId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.contractData = res.data.data
              }
            }catch (e) {

            }
          }
        )
      }*/
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingDetail.vue